import React, { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faFilter, faTrash } from '@fortawesome/free-solid-svg-icons';
import BlogPostsTable from '../components/AdminBlogPostsPage/BlogPostsTable';
import BlogPostAddModal from '../components/AdminBlogPostsPage/BlogPostAddModal';
import BlogPostEditModal from '../components/AdminBlogPostsPage/BlogPostEditModal';
import BlogPostDeleteModal from '../components/AdminBlogPostsPage/BlogPostDeleteModal';
import BlogPostsBulkActions from '../components/AdminBlogPostsPage/BlogPostsBulkActions';
import BlogPostsBulkDeleteModal from '../components/AdminBlogPostsPage/BlogPostsBulkDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import { useBlogPostActions } from '../hooks/AdminBlogPostsPage/useBlogPostActions';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';
import '../styles/AdminPage.css';
import '../styles/AdminBulkActions.css';

const AdminBlogPostsPage = () => {
  const {
    posts,
    allPosts,
    categories,
    loading,
    error,
    selectedPosts,
    filters,
    fetchData,
    handleAddPost,
    handleUpdatePost,
    handleDeletePost,
    handleBulkDeletePosts,
    handleSelectPost,
    handleSelectAllPosts,
    handleFilterChange,
    clearFilters,
  } = useBlogPostActions();

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  // Memoize the filter function to prevent infinite re-renders
  const handleSearchFilter = useCallback((searchTerm) => {
    handleFilterChange('search', searchTerm);
  }, [handleFilterChange]);

  const handleEdit = (post) => {
    setSelectedPost(post);
    setShowEditModal(true);
  };

  const handleDelete = (post) => {
    setSelectedPost(post);
    setShowDeleteModal(true);
  };

  const handleView = (post) => {
    // Implementar vista previa del post
    window.open(`/blog/${post.slug}`, '_blank');
  };

  const handleAddSuccess = () => {
    console.log('🔍 [AdminBlogPostsPage] handleAddSuccess called');
    setShowAddModal(false);
    // Refresh the data to show the new post
    console.log('🔍 [AdminBlogPostsPage] Calling fetchData after add');
    fetchData();
  };

  const handleEditSuccess = () => {
    console.log('🔍 [AdminBlogPostsPage] handleEditSuccess called');
    setShowEditModal(false);
    setSelectedPost(null);
    // Refresh the data to show the updated content
    console.log('🔍 [AdminBlogPostsPage] Calling fetchData after edit');
    fetchData();
  };

  const handleDeleteSuccess = () => {
    console.log('🔍 [AdminBlogPostsPage] handleDeleteSuccess called');
    setShowDeleteModal(false);
    setSelectedPost(null);
    // Refresh the data to reflect the deletion
    console.log('🔍 [AdminBlogPostsPage] Calling fetchData after delete');
    fetchData();
  };

  if (loading) {
    return (
      <div className="admin-page">
        <AdminTableLoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-page">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
          <h1>Blog Posts</h1>
        </div>
        
      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleSearchFilter} />
          <BlogPostsBulkActions
            selectedPosts={selectedPosts}
            clearSelectedPosts={() => handleSelectAllPosts(false)}
            onBulkDelete={handleBulkDeletePosts}
          />
          <div className="admin-page__tools_buttons">
            <button className="button primary" onClick={() => setShowAddModal(true)}>
            Add Post
          </button>
        </div>
      </div>

      <BlogPostsTable
        posts={posts}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onView={handleView}
          onSelectPost={handleSelectPost}
          selectedPosts={selectedPosts}
          onSelectAll={handleSelectAllPosts}
        />
        
        <div className="admin-page__footer">
          <p>Blog posts count: {posts.length}</p>
        </div>
      </div>

      <BlogPostAddModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={handleAddSuccess}
        categories={categories}
      />

        <BlogPostEditModal
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          onSuccess={handleEditSuccess}
          post={selectedPost}
          categories={categories}
        />

        <BlogPostDeleteModal
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onSuccess={handleDeleteSuccess}
          post={selectedPost}
      />
    </div>
  );
};

export default AdminBlogPostsPage; 